<template>
  <form-generator
    key="form-generator-prop-designer"
    :schema="schema"
    :readonly="readonly"
    :cancel="cancel"
    @submit="onSubmit"
    @cancel="onCancel"
    :submit-title="submitTitle"
    :submit-loader="submitLoader"
  />
</template>

<script>
import FormGenerator from '@/components/common/form-generator/FormGenerator'

export default {
  name: 'ProposalRenderer',
  props: {
    submitTitle: String,
    proposals: Array,
    cancel: Boolean,
    readonly: Boolean,
    askBusinessReason: {
      type: Boolean,
      default: false
    },
    submitLoader: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    schema: []
  }),
  components: {
    FormGenerator
  },
  created: function() {
    this.refreshSchema()
  },
  mounted() {
    this.refreshSchema()
  },
  watch: {
    proposals: function() {
      this.refreshSchema()
    }
  },
  methods: {
    refreshSchema() {
      if (this.proposals) {
        this.schema = []
        this.proposals.forEach(proposal => {
          this.schema.push(this.getSchemaFromProposal(proposal))
        })
      }
    },
    getSchemaFromProposal(proposal) {
      let field = {
        key: proposal.key,
        type: proposal.type.toLowerCase(),
        default: proposal.defaultValue,
        items: proposal.items,
        required: proposal.required,
        options: {
          label: proposal.label || proposal.key,
          hint: proposal.description,
          multiple: proposal.fileProps ? proposal.fileProps.multiple : null,
          acceptFormats: proposal.fileProps
            ? proposal.fileProps.acceptFormats
            : null,
          selectProps: proposal.selectProps,
          additionalInfo: proposal.additionalInfo,
          outline: proposal.outline || true,
          cssClass: proposal.cssClass || 'mx-1 my-1'
        }
      }
      if (proposal.deepStructure) {
        field.options.deepStructure = proposal.deepStructure.map(p =>
          this.getSchemaFromProposal(p)
        )
      }

      return field
    },

    onSubmit: function(model) {
      this.$emit('submit', model)
    },

    onCancel: function() {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped></style>
